import React from "react";
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import update from 'immutability-helper';
import {withRouter} from "react-router";
import {Draggable, Droppable} from "react-beautiful-dnd";
import RenderField from "./components/RenderField";
import {insertField} from './actions'
import style from './canvas.scss'
import FormEditor from './components/formEditor'
import {fieldCopy, findFieldById, GridCount} from './schema'
import Sections from './sections'

//
// import {spring} from "react-motion";

// import {useTransition, animated} from 'react-spring'
// import {useSpring, animated} from 'react-spring'

const grid = 6;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer


    // change background colour if dragging
    background: isDragging ? "#fff" : "",
    'border': isDragging ? "1px solid rgba(28, 1, 255, 0.2)" : "none",
    'borderRadius': isDragging ? "3px" : "none",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    'WebkitBoxShadow': isDraggingOver ? "0px 1px 6px 1px rgba(28,1,255,0.09)" : "none",
    'MozBoxShadow': isDraggingOver ? "0px 1px 6px 1px rgba(28,1,255,0.09)" : "none",
    'boxShadow': isDraggingOver ? "0px 1px 6px 1px rgba(28,1,255,0.09)" : "none",
});


const colClasses = [
    style.col1, style.col2, style.col3, style.col4, style.col5, style.col6
]
let fieldPos = {}
const totalHeight = 0;

class Canvas extends React.Component {
    

    // onDrag = (dragIndex, hoverIndex) => {
    //
    //     const updated_fields = {[this.props.section]: {...this.props.reduxFields}}
    //     // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])
    //     const temp = updated_fields[this.props.section].fields[dragIndex];
    //
    //     updated_fields[this.props.section].fields.splice(dragIndex, 1);
    //     updated_fields[this.props.section].fields.splice(hoverIndex, 0, temp);
    //
    //     // updated_fields[this.props.section].fields.splice(dragIndex+1, 0, updated_fields[this.props.section].fields[dragIndex]);
    //
    //     this.props.dispatch(insertField(updated_fields))
    //
    //     this.closeEditor()
    // }

    findTargetIndex = ((fields, index) => {
        let col = 0;
        let dndholderTarget = false;
        fields.forEach((field, i) => {
            col += field.col;
            if (col >= 6 && dndholderTarget === false) {
                if (i === index) {
                    dndholderTarget = i + 1;

                } else if (i > index) {
                    dndholderTarget = col === 6 ? i + 1 : i;
                }
                col = col === 6 ? 0 : field.col;

            }

        })
        return dndholderTarget;
    })

    onDragFieldOverPreview = (f, index) => {

        const updated_fields = {[this.props.section]: {...this.props.reduxFields}}
        const dndholder_pos = updated_fields[this.props.section].fields.findIndex(e => e.type === 'dndholder')
        const temp = updated_fields[this.props.section].fields[dndholder_pos];

        const col = 0;


        if (index === dndholder_pos) {
            return;
        }
        const dndholderTarget = this.findTargetIndex(updated_fields[this.props.section].fields, index);
        // row.push(<div className={style.row}></div>)
        // updated_fields[this.props.section].fields.forEach((field, i) => {
        //     col += field.col;
        //
        //     if (col >= 6 && dndholderTarget === false) {
        //         if (i == index) {
        //             dndholderTarget = i + 1;
        //
        //         } else if (i > index) {
        //             dndholderTarget = col == 6 ? i + 1 : i;
        //         }
        //         col = col == 6 ? 0 : field.col;
        //
        //     }
        //
        // })

        if (index == dndholder_pos || dndholderTarget == dndholder_pos || index == dndholderTarget) {
            return;

        }


        updated_fields[this.props.section].fields.splice(dndholder_pos, 1);
        updated_fields[this.props.section].fields.splice(dndholderTarget, 0, temp);


        this.props.dispatch(insertField(updated_fields))
    }

    // onDrop = (item, index, offset = false) => {
    //     let dndholderTarget = index;
    //     const updated_fields = {[this.props.section]: {...this.props.reduxFields}}
    //     if (index === false) {
    //         let top = 65;
    //         let left = 0;
    //         let height = 0;
    //         let col = 0;
    //         for (let i = 0; i < this.props.fields.fields.length; i++) {
    //             const field = this.props.fields.fields[i];
    //             if (i == 0) {
    //                 col = field.col;
    //                 left = 0;
    //                 height = 0;
    //
    //             } else {
    //                 col += field.col;
    //                 if (col > 6) {
    //                     col = field.col;
    //                     left = 0;
    //
    //                     top += height;
    //                     height = 0;
    //
    //                 } else {
    //                     left += (this.state.fieldPos[this.props.fields.fields[i - 1].elementId] ? this.state.fieldPos[this.props.fields.fields[i - 1].elementId].width : 100)
    //
    //                 }
    //
    //             }
    //             height = Math.max(height, (this.state.fieldPos[this.props.fields.fields[i].elementId] ? this.state.fieldPos[this.props.fields.fields[i].elementId].height : 100));
    //             index = i;
    //             if (top > offset.y) {
    //                 break;
    //             }
    //         }
    //         dndholderTarget = index;
    //     } else {
    //         dndholderTarget = this.findTargetIndex(updated_fields[this.props.section].fields, index);
    //     }
    //
    //
    //     // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])
    //
    //
    //     updated_fields[this.props.section].fields.splice(dndholderTarget, 0, {
    //         ...fieldDefinitions(item.field.key)
    //     });
    //     setTimeout(
    //         function () {
    //             const dndholder_pos = updated_fields[this.props.section].fields.findIndex(e => e.type === 'dndholder')
    //             const temp = updated_fields[this.props.section].fields[dndholder_pos];
    //             updated_fields[this.props.section].fields.splice(dndholder_pos, 1);
    //             updated_fields[this.props.section].fields.push(temp);
    //             this.props.dispatch(insertField(updated_fields))
    //         }
    //             .bind(this),
    //         1000
    //     );
    //
    //     this.props.dispatch(insertField(updated_fields))
    //     this.closeEditor()
    // }

    openEditor = (field, index) => {

        this.setState((prevState) => ({
            ...prevState,
            showPopup: true,
            popUpField: {field, index},

        }));

    }

    closeEditor = () => {

        this.setState((prevState) => ({
            ...prevState,
            showPopup: false,
            popUpField: {}
        }));

    }

    updatefieldPos = (elementRef, id) => {
        if (elementRef && elementRef.current) {
            const pos = {
                height: elementRef.current.clientHeight,
                width: elementRef.current.clientWidth
            }
            fieldPos = update(fieldPos, {[id]: {$set: pos}})
            // let temp = this.state.fieldPos;
            // temp[i]= pos;
            this.setState((prevState) => (
                {
                    ...prevState,
                    fieldPos
                }
            ))
        }


    }

    changeCol = (change, field) => {
        // const row = this.props.fields.f
        const {reduxFields, section, dispatch} = this.props;
        const {row, col} = findFieldById(field.elementId, reduxFields.fields)

        let updatedFields = {
            [section]: {
                ...update(reduxFields, {
                    fields: {
                        [row]: {
                            [col]: {
                                col: {$set: Math.min(6, Math.max(6 / GridCount, field.col + change * 6 / GridCount))}
                            }
                        }
                    }
                })
            }
        }

        updatedFields = this.updateRowAndColum(updatedFields, section, row, col);

        dispatch(insertField(updatedFields))
    }

    updateRowAndColum = (updatedFields, section, row, col) => {
        const colSum = updatedFields[section].fields[row].reduce((a, b) => a + b.col, 0)
        if (colSum > 6) {
            const lastItemCol = updatedFields[section].fields[row][updatedFields[section].fields[row].length - 1].col;
            const temp = updatedFields[section].fields[row][updatedFields[section].fields[row].length - 1];
            updatedFields[section].fields[row].splice(updatedFields[section].fields[row].length - 1, 1);

            if (updatedFields[section].fields[row + 1]) {
                const NextColSum = updatedFields[section].fields[row + 1].reduce((a, b) => a + b.col, 0);
                if ((NextColSum + lastItemCol) <= 6) {
                    // prepend lastItemCol to next
                    updatedFields[section].fields[row + 1].splice(0, 0, temp);
                } else {
                    updatedFields[section].fields.splice(row + 1, 0, [temp]);
                }
            } else {
                updatedFields[section].fields.splice(row + 1, 0, [temp]);
            }
        }
        return updatedFields;
    }

    handleCopy = (field) => {

        const {reduxFields, section, dispatch} = this.props;

        const {row, col} = findFieldById(field.elementId, reduxFields.fields)

        let updatedFields = {[section]: {...reduxFields}}
        // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])

        updatedFields[section].fields[row].splice(col + 1, 0, {
            ...fieldCopy(field, section),
        });
        updatedFields = this.updateRowAndColum(updatedFields, section, row, col);

        dispatch(insertField(updatedFields))

        this.closeEditor()


    }
 
    handleRemove = (field) => {
        const {reduxFields, section, dispatch} = this.props;
        const {row, col} = findFieldById(field.elementId, reduxFields.fields)
        const updatedFields = {[section]: {...reduxFields}}
        updatedFields[section].fields[row].splice(col, 1);

        if (updatedFields[section].fields[row].length === 0) {
            updatedFields[section].fields.splice(row, 1)
        }
        dispatch(insertField(updatedFields))
        this.closeEditor()
    }

    handleChange = (field) => {

        const index = this.props.reduxFields.findIndex(e => e.elementId === field.elementId);
        if (index !== -1) {
            const updated_fields = {[this.props.section]: {...update(this.props.reduxFields, {fields: {[index]: {$set: field}}})}}
            this.props.dispatch(insertField(updated_fields))
        }


    }

    openSettings = fieldId => {
        const {history, section, changeTab} = this.props;
        changeTab('options');
        history.push(`/section/${  section  }/${  fieldId}`);
    }

    onDragStart = start => {
        // console.log(start)
        if (start.source.droppableId !== "droppable") {
            const {reduxFields} = this.props;
            const {field} = findFieldById(start.draggableId, reduxFields.fields)
            this.setState((prevState) => ({
                ...prevState,
                isRowDraging: false,
                dragItemCol: field.col,
                dragItemId: start.draggableId
            }));
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            popUpField: false,
            fieldPos: {},
            isRowDraging: true,
            dragItemCol: 6,
            dragItemId: false
        }
        this._ismounted = false;

        this.myRef = React.createRef();
        this.onDragEnd = this.onDragEnd.bind(this);


    }

    onDragEnd(result) {
        // dropped outside the list
        const {section, reduxFields, dispatch} = this.props;
        this.setState((prevState) => ({
            ...prevState,
            isRowDraging: true,
            dragItemCol: 6,
            dragItemId: false

        }));
        if (result.destination) {

            // console.log(result.source);
            // console.log(result.destination);
            // console.log(result);

            const updatedFields = {[section]: {...reduxFields}}

            if (result.type === 'row') {
                const sourceRow = result.source.index;
                const destinationRow = result.destination.index;
                const temp = updatedFields[section].fields[sourceRow];
                updatedFields[section].fields.splice(sourceRow, 1);
                updatedFields[section].fields.splice(destinationRow, 0, temp);

            } else if (result.destination.droppableId === 'droppable') {

                const sourceRow = parseInt(result.source.droppableId) - 1;
                const destinationRow = parseInt(result.destination.index);
                // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])
                const temp = updatedFields[section].fields[sourceRow][result.source.index];
                updatedFields[section].fields[sourceRow].splice(result.source.index, 1);
                updatedFields[section].fields.splice(destinationRow, 0, [temp]);

                if (updatedFields[section].fields[sourceRow].length === 0) {
                    updatedFields[section].fields.splice(sourceRow, 1)
                }

            } else {
                const sourceRow = parseInt(result.source.droppableId) - 1;
                const destinationRow = parseInt(result.destination.droppableId) - 1;
                // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])
                const temp = updatedFields[section].fields[sourceRow][result.source.index];
                updatedFields[section].fields[sourceRow].splice(result.source.index, 1);
                updatedFields[section].fields[destinationRow].splice(result.destination.index, 0, temp);

                if (updatedFields[section].fields[sourceRow].length === 0) {
                    updatedFields[section].fields.splice(sourceRow, 1)
                }


                // const colSum = updatedFields[section].fields[destinationRow].reduce((a, b) => a + b.col, 0);
                // if (colSum > 6) {
                //     const colSumNextRow = updatedFields[section].fields[destinationRow + 1] &&
                //         updatedFields[section].fields[destinationRow + 1].reduce((a, b) => a + b.col, 0);
                //     if(colSumNextRow || colSumNextRow==6){
                //
                //     }
                // }


            }


            // updated_fields[this.props.section].fields.splice(dragIndex+1, 0, updated_fields[this.props.section].fields[dragIndex]);

            dispatch(insertField(updatedFields))
        }

        // const items = reorder(
        //     this.state.items,
        //     result.source.index,
        //     result.destination.index
        // );
        //
        // this.setState({
        //     items
        // });
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(totalHeight)
        // console.log(this.myRef.current.style.height=totalHeight)
        // this.myRef.current.style.height = `${totalHeight + 100  }px`;
        // this.props.connectDropTarget = this.myRef;

        // Object.entries(this.props).forEach(([key, val]) => {
        //
        //         return prevProps[key] !== val && console.log(`Prop '${key}' changed`)
        //     }
        // );
        // Object.entries(this.state).forEach(([key, val]) =>
        //     prevState[key] !== val && console.log(`State '${key}' changed`)
        // );
    }

    componentDidMount() {

        this._ismounted = true;

    }


    render() {
        const {isOver, canDrop, connectDropTarget, history, section, reduxFields} = this.props
        const {isColDraging, dragItemCol, dragItemId, matchParams, dragSourceRowId} = this.props;
        const activeElementId = typeof matchParams.fieldId !== "undefined" ? matchParams.fieldId : false;

        const isActive = canDrop && isOver

        let disableAllDrag = false;
        if (window.awcfe_object.isMlActive && window.awcfe_object.ml.isDefault === false ) {
            disableAllDrag = true;
        }

        // let col = 0;
        // const rows = []
        // let cols = []
        // // row.push(<div className={style.row}></div>)
        // this.props.fields.fields.map((field, i) => {
        //     col += field.col;
        //     if (col > 6) {
        //         col = field.col;
        //         rows.push(cols)
        //         cols = []
        //     }
        //     cols.push({field, index: i})
        //
        // })

        // rows.push(cols)
        // console.log(rows);
        const top = 0;
        const left = 0;
        const height = 0;
        const gap = 10;
        // { console.log(reduxFields.fields); }
        return (
           
            (section == undefined) ? <Redirect from="/" to="/section/billing"/> : (


                <>

                    <div className={style.navSection}>
                        {/* <Sections */}
                        {/*    activeSection={section} */}
                        {/*    addNewSection={this.props.addNewSection} */}
                        {/*    duplicateSection={this.props.duplicateSection} */}
                        {/*    deleteSection={this.props.deleteSection} */}
                        {/* /> */}
                    </div>
                    <Droppable
                        droppableId={`${section}-canvas`}
                        // type={reduxFields.fields.length ? 'row' : 'column'}
                        type="column"
                    >
                        {(provided, snapshot) => (
                            <div
                                className={style.canvas + " " + (reduxFields.fields.length === 0 ? style.empty : '')}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                 {/*{console.log(reduxFields.fields)}*/}
                                {reduxFields.fields.map((row, i) => {
                                        const colSum = row.reduce((a, b) => a + b.col, 0)

                                        return (
                                            <Draggable
                                                key={`d${i}`}
                                                draggableId={`row-${i}`}
                                                index={i}
                                                isDragDisabled={disableAllDrag}
                                            >

                                                {(provided, snapshot) => (

                                                    <div
                                                        className={style.rowWrap + ' ' +
                                                        '' + ((snapshot.isDragging) ? style.rowDrag : '') + " " +
                                                        "" + ((isColDraging && (dragSourceRowId === section + "-row-" + i)) ? style.dragSourceRow : '')}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        <Droppable
                                                            droppableId={`${section}-row-${i}`}
                                                            direction="horizontal"
                                                            type="column"
                                                            // isDropDisabled={true}
                                                            isDropDisabled={(!row.find(e => e.elementId === dragItemId) && (dragItemCol + colSum) > 6)}
                                                        >
                                                            
                                                            {(providedRow, snapshotRow) => (


                                                                <div
                                                                    className={style.row}
                                                                    {...providedRow.droppableProps}
                                                                    ref={providedRow.innerRef}
                                                                    style={getListStyle(snapshotRow.isDraggingOver)}>
                                                                    {
                                                                        row.map((col, j) => {
                                                                            const field = col;
                                                                            const statusClass = field.active ? style.activeField : style.inActiveField;
                                                                            const isOpenField = field.elementId === activeElementId ? true : false;
                                                                            return (

                                                                                <Draggable
                                                                                    key={field.elementId}
                                                                                    draggableId={`column-${field.col}-${field.elementId}`}
                                                                                    index={j}
                                                                                    isDragDisabled={field.col === 6 ? true : (disableAllDrag)}
                                                                                >
                                                                                    {(providedRow, snapshotRow) => (
                                                                                        <div
                                                                                            className={`${colClasses[field.col - 1]} ${style.cols} ${statusClass}`}
                                                                                            ref={providedRow.innerRef}
                                                                                            {...providedRow.draggableProps}
                                                                                            {...providedRow.dragHandleProps}
                                                                                            style={getItemStyle(
                                                                                                snapshotRow.isDragging,
                                                                                                providedRow.draggableProps.style
                                                                                            )}>
                                                                                               
                                                                                            
                                                                                            <RenderField
                                                                                                onClick={this.openSettings}
                                                                                                openEditor={this.openEditor}
                                                                                                field={field}
                                                                                                activeClass={isOpenField}
                                                                                                onDragFieldOverPreview={this.onDragFieldOverPreview}
                                                                                                changeCol={this.changeCol}
                                                                                                handleCopy={this.handleCopy}
                                                                                                handleRemove={this.handleRemove}
                                                                                                updatefieldPos={this.updatefieldPos}
                                                                                                index={j}
                                                                                                key={field.elementId}

                                                                                            />
                                                                                             


                                                                                        </div>

                                                                                    )}
                                                                                </Draggable>


                                                                            )


                                                                        })
                                                                    }
                                                                    {providedRow.placeholder}
                                                                </div>


                                                            )}
                                                        </Droppable>

                                                        {/*<Droppable*/}
                                                        {/*droppableId={`${section}-placeholder-${i + 1}`}*/}
                                                        {/*direction="horizontal"*/}
                                                        {/*type="column"*/}

                                                        {/*// isDropDisabled={true}*/}
                                                        {/*//        isDropDisabled={isRowDraging || (!row.find(e => e.elementId === dragItemId) && (dragItemCol + colSum) > 6)}*/}
                                                        {/*>*/}
                                                        {/*{(providedRow, snapshotRow) => (*/}
                                                        {/*<div*/}
                                                        {/*className={`${style.rowPlaceHolder} ${isColDraging && style.isColDraging}`}*/}
                                                        {/*{...providedRow.droppableProps}*/}
                                                        {/*ref={providedRow.innerRef}*/}
                                                        {/*style={{*/}
                                                        {/*...getListStyle(snapshotRow.isDraggingOver),*/}
                                                        {/*// height: snapshotRow.isDraggingOver ? 150 : 10*/}
                                                        {/*}}*/}


                                                        {/*/>*/}
                                                        {/*)}*/}
                                                        {/*</Droppable>*/}


                                                    </div>
                                                )}
                                            </Draggable>


                                        )


                                    }
                                )}


                                {
                                    this.state.showPopup ? <FormEditor handleChange={(field) => {
                                        this.handleChange(field)
                                    }} closePopup={this.closeEditor}
                                                                       index={this.state.popUpField.index}
                                                                       field={this.props.reduxFields.fields[this.state.popUpField.index]}/> : ''
                                }
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                    {/* <div className={style.canvas}> */}

                    {/**/}

                    {/* </div> */}
                </>


            )

        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const $section = ownProps.matchParams.sectionId;

    let reduxFields = {fields: []};
    if (typeof  state.fields.data !== "undefined" && typeof  state.fields.data[$section] !== 'undefined') {
        reduxFields = state.fields.data[$section]
    }
    return {
        reduxFields,
        section: $section,
        version: typeof state.fields.version !== "undefined" ? state.fields.version : 0
    }
}
// export default connect(mapStateToProps)(Canvas)
// export default (connect(mapStateToProps)(DropTarget(
//     ItemTypes.FIELD,
//     {
//         drop(props, monitor, component) {
//             const hasDroppedOnChild = monitor.didDrop()
//             console.log('hasDroppedOnChild');
//             console.log(hasDroppedOnChild);
//             if (hasDroppedOnChild) {
//                 return
//             }
//             const item = monitor.getItem();
//             component.onDrop(item, false, monitor.getClientOffset());
//             // monitor.getClientOffset()
//             // let item = monitor.getItem();
//             // let updated_fields = {[props.section]: {...props.fields}}
//             // updated_fields[props.section].fields.push(fieldDefinitions(item.field.key))
//             // props.dispatch(insertField(updated_fields))
//         },
//     },
//     (connect, monitor) => ({
//         connectDropTarget: connect.dropTarget(),
//         isOver: monitor.isOver(),
//         canDrop: monitor.canDrop()
//     }),
// )(Canvas)))
export default connect(mapStateToProps)(withRouter(Canvas))
